/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";
import { SpinnerLoading } from "../utils/SpinnerLoading";
import { ErrorMessage } from "../utils/ErrorMessage";
import { fetchRecords } from "../utils/AppUtil";
import { Link } from "react-router-dom";

class Consecration {
    deceasedId: string;
    consecrationDate: string;
    consecrationTime: string;
    deceased: string;
    cemeteryName: string;
    constructor(deceasedId: string, consecrationDate: string, consecrationTime: string, deceased: string, cemeteryName: string) {
        this.deceasedId = deceasedId;
        this.consecrationDate = consecrationDate;
        this.consecrationTime = consecrationTime;
        this.deceased = deceased;
        this.cemeteryName = cemeteryName; 
    }
}

type WeeklyConsecrationProps = {
    endpoint: string;
    recordCount: number;
}

export const WeeklyConsecration: React.FC<WeeklyConsecrationProps> = (props) => {
    
    const [records, setRecords] = useState<Consecration[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [httpError, setHttpError] = useState(null);
    const [endpoint, setEndpoint] = useState(`${props.endpoint}?count=${props.recordCount}`);

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            setIsLoading(false);
            setHttpError(error.message);
        });

    }, [endpoint]);

    // You may edit this function to manipulate the way your code is processed.
    const processData = (responseJson: any) => { // Do not edit these parameters, just the content of this function.
        const recordData: Consecration[] = [];
    
        for(const key in responseJson) {
            const record: any = responseJson[key];
            const deceasedId = record["deceasedId"];
            const consecrationDate: string = record["consecrationDateDisplay"];
            const consecrationTime: string = record["consecrationTimeDisplay"];
            const deceased: string = (record["firstName"] ? record["firstName"] : " ") + " " + (record["lastName"] ? record["lastName"] : "");
            const cemeteryName: string = record["cemeteryName"];

            recordData.push(new Consecration(deceasedId, consecrationDate, consecrationTime, deceased, cemeteryName));
        }
        
        setRecords(recordData);
        setIsLoading(false);
    }

    if(isLoading) {
        return(
            <SpinnerLoading />
        )
    }

    if(httpError) {
        return(
            <ErrorMessage error={httpError} />
        )
    }

    const result: React.ReactElement[] = [];

    records.forEach((consecration, index) => {
        result.push(
            <tr key={index}>
                <td className="jc-txt-body fs-6 fw-bold table-mobile-left">
                    <Link to={'/deceased/' + consecration.deceasedId} className="jc-txt-blue">{consecration.deceased}</Link>
                </td>
                <td className="jc-txt-body fs-7 align-end table-mobile-right" style={{whiteSpace: "nowrap"}}>
                    <span>{consecration.consecrationDate}</span>
                    <span>{consecration.cemeteryName ? " • " + consecration.cemeteryName : ""}</span>
                    <span>{consecration.consecrationTime ? " • " + consecration.consecrationTime : ""}</span>
                </td>
            </tr>
        )
    });

    return (
        <div className="card card-consecration jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Upcoming Consecrations</p>
            </div>

            <div className="card-body p-0">
                <div className="table-upcoming-consecrations">
                    <table className="table table-striped table-consecration mb-0">
                        <tbody>
                            {result}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}